import { Routes, Route } from 'react-router-dom';
import { Paths } from '../Constants';

import Home from './Home';

function Router() {
    return (
        <Routes>
            <Route path={Paths.HOME} element={<Home />} />
        </Routes>
    );
}
export default Router;
